<template lang="pug">
  d-file-uploader-base(
    @uploaded="onUploaded"
    @loading="$emit('loading', $event)"
    v-slot="{ upload, loading }"
  )
    dv-form(
      ref="form"
      v-model="formData"
      :schema="schema"
      :submit-callback="() => onUpload({ upload })"
      :nestable="false"
      v-slot="{ fields }"
    )
      dv-form-field(
        :field="fields[namespace]"
        :loading="loading"
      )
        template(v-slot:default="props")
          slot(v-bind="props")
</template>

<script>
import DvForm from '../../forms/DvForm.vue';
import DvFormField from '../../forms/DvFormField.vue';
import DFileUploaderBase from '../DFileUploader/DFileUploaderBase.vue';
import DDragAndDropInput from '../DFileUploader/DDragAndDropInput.vue';

export default {
  components: {
    DvForm,
    DvFormField,
    DFileUploaderBase,
    DDragAndDropInput,
  },
  props: {
    namespace: {
      type: String,
      default: 'data',
    },
    serializeData: {
      type: Function,
      default: ({ data }) => data,
    },
    returnMultiple: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [String, Object],
      default: undefined,
    },
    value: {
      type: [String, Object, Array],
      default: undefined,
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value,
      formData: {},
    };
  },
  watch: {
    value(val) {
      this.inputValue = val;
    },
    inputValue(val) {
      const { formData, namespace } = this;

      if (!val) this.$set(formData, namespace, undefined);
    },
    isValid(val) {
      if (val) this.submit();
    },
  },
  computed: {
    schema() {
      const {
        rules,
        multiple,
        namespace,
        accept,
        hideButton,
      } = this;

      return [
        {
          name: namespace,
          value: namespace,
          rules,
          component: DDragAndDropInput,
          props: {
            multiple,
            accept,
            hideButton,
          },
          rulesProps: (r) => ({
            accept: r?.mimes || accept,
          }),
        },
      ];
    },
    isValid() {
      const { namespace } = this;
      return !!this.formData?.[namespace]?.length;
    },
  },
  methods: {
    submit() {
      this.$refs.form.submit();
    },
    onUpload({ upload }) {
      const { namespace } = this;
      const value = this.formData[namespace];

      upload(value);
    },
    onUploaded(val) {
      const { multiple, returnMultiple, serializeData } = this;
      const first = 0;

      const outputData = (multiple || returnMultiple) ? val : val?.at(first);
      const serializedData = (multiple || returnMultiple)
        ? outputData.map((data) => serializeData(data))
        : serializeData(outputData);

      this.$emit('input', serializedData);
    },
  },
};
</script>
